<div class="page-wrapper" [attr.data-testid]="pageId">
    @for (tile of tiles; track tile.id) {
        <mat-card class="card-button card-border card-container">
            <div class="card-button__image-container center-icon">
                <span class="material-symbols-outlined size-48" alt="" aria-hidden="true">{{ tile.icon }}</span>
            </div>
            <mat-card-content class="card-content">
                <p>
                    <strong>{{ tile.header }}</strong>
                </p>
                <div class="course-card-top">
                    <span class="text-default">
                        {{ tile.subheader }}
                    </span>
                </div>
            </mat-card-content>
            <div class="arrow-icon center-icon">
                <span class="material-symbols-outlined">chevron_right</span>
            </div>
            @if (tile.link.startsWith("/")) {
                <a
                    mat-button
                    class="card-button-link"
                    [routerLink]="tile.link"
                    [attr.id]="tile.id"
                    [attr.title]="tile.title"
                    [attr.target]="tile.target ? tile.target : '_self'"
                >
                </a>
            } @else {
                <a
                    mat-button
                    class="card-button-link"
                    [href]="tile.link"
                    [attr.id]="tile.id"
                    [attr.title]="tile.title"
                    [attr.target]="tile.target ? tile.target : '_self'"
                >
                </a>
            }
        </mat-card>
    }
</div>

<case-list></case-list>
